import { SET_USER_AGENT } from '../actions/set-user-agent';

const userAgent = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_USER_AGENT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default userAgent;



// WEBPACK FOOTER //
// ./app/reducers/user-agent.js